import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ToastComponent } from '../../shared/toast/toast.component';
import { ClientService } from '../../services/client.service';
import { AuthService } from '../../services/auth.service';
import { Client } from '../../shared/models/client.model';
import { ee, profilePics } from '../../shared/constants';
import { sortArrayByDateFieldDesc } from '../../shared/functions';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
  standalone: false
})
export class ClientComponent implements OnInit {
  auth = inject(AuthService);
  private router = inject(Router);
  private clientService = inject(ClientService);
  toast = inject(ToastComponent);


  @Input() client: Client;

  isDetailsPage = false;
  isEditClientModalVisible = false;
  field = '';
  lastContractName = '';
  profilePics = profilePics;

  ngOnInit(): void {
    if (!this.client) {
      this.toast.setMessage('This client does not exists!', 'danger');
      this.router.navigate(['/clients']);
      return;
    }
    if (this.router.url.includes('client/')) {
      this.isDetailsPage = true;
    }
    if (this.client.contracts?.length) {
      // Sort contracts by date DESC to get the newest contract
      this.client.contracts = sortArrayByDateFieldDesc(this.client.contracts, 'endDate');
      this.lastContractName = this.client.contracts[0].name;
    }
  }

  toggleEditClientModal(field: string): void {
    this.isEditClientModalVisible = true;
    this.field = field;
    ee.emit('showEditClientModal', field);
  }

  deleteClient(client: Client): void {
    if (window.confirm(`Are you sure you want to delete ${client.name}?`)) {
      this.clientService.delete(client)
        .pipe(finalize(() => this.router.navigate(['/clients'])))
        .subscribe({
          next: res => this.toast.setMessage('Client deleted successfully.', 'success'),
          error: err => this.toast.setMessage(err.error.message, 'danger')
        });
    }
  }

}
